/* eslint-disable no-console */
import ServiceBase from './serviceBase';
import {
  FlowCreate,
  FlowContainer,
  FlowNextReview,
  FlowFeedbackProvided,
  OperFlowService,
  FlowFeedbackForSave,
  InviteReviewers,
  FlowRestart,
  FlowRelate,
  FlowReviewerDelete,
  FlowEsapInfo,
  FlowSprMission,
  FlowSprDoc,
} from './types/Flow';

const NOT_IMPLEMENTED_ERROR_MESSAGE = 'Not Implemented';

class OperEssService extends ServiceBase implements OperFlowService {
  create = async (data: FlowCreate): Promise<number> =>
    this.post<number>('operationess/create', data);

  getFlow = async (operationId: number): Promise<FlowContainer> =>
    this.get<FlowContainer>(`operationess/${operationId}`);

  sendForNextReview = async (data: FlowNextReview): Promise<void> =>
    this.post<void>('operationess/next', data);

  provideFeedback = async (data: FlowFeedbackProvided): Promise<void> =>
    this.post<void>('operationess/feedback', data);

  saveFeedback = async (data: FlowFeedbackForSave): Promise<void> =>
    this.post<void>('operationess/savefeedback', data);

  applyComplianceChanges = async (flowId: number): Promise<void> =>
    this.post<void>(`operationess/${flowId}/applycompliance`);

  discardComplianceChanges = async (flowId: number): Promise<void> =>
    this.post<void>(`operationess/${flowId}/discardcompliance`);

  openWord = async (flowId: number): Promise<string> =>
    this.post<string>(`operationess/${flowId}/wordlink`);

  downloadDocVersion = async (id: number): Promise<boolean> => {
    await this.download(`operationess/version/${id}`);
    return true;
  };

  upload = async (formData: FormData): Promise<boolean> => {
    const result = await this.post<boolean>('operationess/upload', formData);
    return result;
  };

  restart = async (data: FlowRestart): Promise<void> =>
    this.post<void>('operationess/restart', data);

  relate = async (data: FlowRelate): Promise<void> => this.post<void>('operationess/relate', data);

  inviteReviewers = async (data: InviteReviewers): Promise<void> =>
    this.post<void>('operationess/invite-reviewers', data);

  applyActionPlanChanges = async (flowId: number): Promise<void> => {
    console.log(flowId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  discardActionPlanChanges = async (flowId: number): Promise<void> => {
    console.log(flowId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  applyIndicatorsChanges = async (flowId: number): Promise<void> => {
    console.log(flowId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  discardIndicatorsChanges = async (flowId: number): Promise<void> => {
    console.log(flowId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  getSPRRationale = async (flowId: number): Promise<FlowSprDoc> => {
    console.log(flowId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  getSPRMissions = async (operationId: number): Promise<FlowSprMission[]> => {
    console.log(operationId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  removeReviewers = async (data: FlowReviewerDelete): Promise<void> =>
    this.post<void>('operationess/remove-reviewers', data);

  checkEsap = async (flowId: number): Promise<FlowEsapInfo> => {
    console.log(flowId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  deleteFlow = async (flowId: number, lap?: number | undefined) => {
    console.log(flowId, lap);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };
}

const operEssService = new OperEssService();

export default operEssService;
